import { Stack, Text, List } from '@chakra-ui/react'
import type { FC } from 'react'

import CardSection from '@app/shared/cards/components/cardSection'
import { useStore } from '@app/store'
import type { CardSize, DomainNode } from '@app/types'
import { formatTotal } from '@app/utils/metricHelpers'

type Props = {
  node: Pick<DomainNode, 'simPartials1p' | 'data'>
  size: CardSize
}
const SimOnePercentPartialsSection: FC<Props> = ({ node, size }) => {
  const partials = node?.simPartials1p
  const thisMetric = node?.data
  const thisName = thisMetric?.name || 'Unnamed'
  const getNodeById = useStore.use.getNodeById()

  if (!partials || partials.length === 0) {
    return null
  }

  return (
    <CardSection size={size}>
      <Stack>
        <Text lineClamp={1} color="fg.muted">
          1% {thisName} change →
        </Text>
        <List.Root variant="plain" ms="0.75em">
          {partials?.map((partial) => {
            const { name, nodeRfId, deltaR } = partial
            const root = getNodeById(nodeRfId)
            const rootMetric = root?.data

            return (
              <List.Item key={partial.nodeId}>
                <Text color="fg.muted">
                  {formatTotal(deltaR, rootMetric?.displayFormat || 'number', rootMetric)} {name} impact
                </Text>
              </List.Item>
            )
          })}
        </List.Root>
      </Stack>
    </CardSection>
  )
}

SimOnePercentPartialsSection.displayName = 'SimOnePercentPartialsSection'

export default SimOnePercentPartialsSection
